import { SET_ROTATIONAL_BANNER_DATA } from '../StoreConstants/BannnersDataConstants';

export const BannersDataStore = {
  state: {
    rotationalBannersData: null,
  },
  mutations: {
    [SET_ROTATIONAL_BANNER_DATA]: (state, payload) => {
      state.rotationalBannersData = payload;
    },
  },
};
